import React, { useState, useEffect } from "react";
import axios from "axios";
import { useReactMediaRecorder } from "react-media-recorder";
function PlaybackAudio() {
    let [audioLoaded, setAudioLoaded] = useState(false);
    let [audioFile, setAudioFile] = useState("");
    let [audioArray, setAudioArray] = useState([]);
    let [audioName, setAudioName] = useState("");
    // let [doneRec, setDoneRec] = useState(false);
    let fetchAllAudio = (url, data) => {
        axios
            .get("https://h4h-backend.herokuapp.com/files", data, {})
            .then(({ data }) => {
                console.log(data);
                setAudioArray(data);
            });
    };
    let fetchAudio = (url, data) => {
        axios
            .get(
                `https://h4h-backend.herokuapp.com/media/${audioName}`,
                data,
                {}
            )
            .then(({ data }) => {
                console.log(data);
                // setAudioFile(data);
                setAudioFile(
                    `https://h4h-backend.herokuapp.com/media/${audioName}`
                );

                setAudioLoaded(true);
            });
    };
    const [second, setSecond] = useState("00");
    const [minute, setMinute] = useState("00");
    const [isActive, setIsActive] = useState(false);
    const [counter, setCounter] = useState(0);

    useEffect(() => {
        let intervalId;

        if (isActive) {
            intervalId = setInterval(() => {
                const secondCounter = counter % 60;
                const minuteCounter = Math.floor(counter / 60);

                let computedSecond =
                    String(secondCounter).length === 1
                        ? `0${secondCounter}`
                        : secondCounter;
                let computedMinute =
                    String(minuteCounter).length === 1
                        ? `0${minuteCounter}`
                        : minuteCounter;

                setSecond(computedSecond);
                setMinute(computedMinute);

                setCounter((counter) => counter + 1);
            }, 650);
        }

        return () => clearInterval(intervalId);
    }, [isActive, counter]);

    function stopTimer() {
        setIsActive(false);
        setCounter(0);
        setSecond("00");
        setMinute("00");
    }

    const {
        status,
        startRecording,
        stopRecording,
        pauseRecording,
        mediaBlobUrl,
    } = useReactMediaRecorder({
        video: false,
        audio: true,
        echoCancellation: true,
    });
    console.log("deed", mediaBlobUrl);

    const convertFileToBase64 = (file) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file.mediaBlobUrl);

            reader.onload = () =>
                resolve({
                    fileName: file.title,
                    base64: reader.result,
                });
            reader.onerror = reject;
        });
    return (
        <div
            style={{
                height: "97vh",
                width: "100vw",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
            }}
        >
            {/* <div>
                <audio controls style={{ background: "green" }}>
                    <source
                        src="https://h4h-backend.herokuapp.com/media/45bc4e0cc3e897e351312a9b66d018c4.wav"
                        type="audio/mpeg"
                    />
                </audio>
            </div> */}
            {/* needs to by dynamic */}

            <div
                className="col-md-6 "
                style={{
                    backgroundColor: "rgba(0, 0,0, 0.8)",
                    padding: "20px",
                    borderRadius: "12px",
                    color: "white",
                    // marginLeft: "357px",
                }}
            >
                {" "}
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                    }}
                >
                    {" "}
                    <h4
                        style={{
                            marginLeft: "10px",
                            textTransform: "capitalize",
                            fontFamily: "sans-serif",
                            fontSize: "18px",
                            color: "white",
                            fontWeight: "800",
                            padding: 10,
                        }}
                    >
                        Status: {status}
                    </h4>{" "}
                    <audio
                        src={mediaBlobUrl}
                        controls
                        loop
                        style={{ marginTop: "20px" }}
                    />
                </div>
                <button
                    style={{
                        backgroundColor: "grey",
                        padding: 4,
                        borderRadius: "8px",
                        color: "white",
                    }}
                    onClick={stopTimer}
                >
                    Clear
                </button>
                <div style={{ fontSize: "54px" }}>
                    <span className="minute">{minute}</span>
                    <span>:</span>
                    <span className="second">{second}</span>
                </div>
                <div>
                    <label
                        style={{
                            fontSize: "15px",
                            fontWeight: "Normal",
                            // marginTop: "20px"
                        }}
                        htmlFor="icon-button-file"
                    >
                        <h3
                            style={{
                                marginLeft: "15px",
                                fontWeight: "normal",
                            }}
                        >
                            Press Start to record
                        </h3>

                        <div>
                            <button
                                style={{
                                    padding: "0.8rem 2rem",
                                    border: "none",
                                    marginLeft: "15px",
                                    fontSize: "1rem",
                                    cursor: "pointer",
                                    borderRadius: "5px",
                                    fontWeight: "bold",
                                    backgroundColor: "#42b72a",
                                    color: "white",
                                    transition: "all 300ms ease-in-out",
                                    transform: "translateY(0)",
                                }}
                                onClick={() => {
                                    if (!isActive) {
                                        startRecording();
                                    } else {
                                        pauseRecording();
                                    }

                                    setIsActive(!isActive);
                                }}
                            >
                                {isActive ? "Pause" : "Start"}
                            </button>
                            <button
                                style={{
                                    padding: "0.8rem 2rem",
                                    border: "none",
                                    backgroundColor: "#df3636",
                                    marginLeft: "15px",
                                    fontSize: "1rem",
                                    cursor: "pointer",
                                    color: "white",
                                    borderRadius: "5px",
                                    fontWeight: "bold",
                                    transition: "all 300ms ease-in-out",
                                    transform: "translateY(0)",
                                }}
                                onClick={() => {
                                    pauseRecording();
                                    stopRecording();
                                    setIsActive(!isActive);
                                }}
                            >
                                Stop
                            </button>
                        </div>
                    </label>
                    <form
                        action="https://h4h-backend.herokuapp.com/upload"
                        method="POST"
                        encType="multipart/form-data"
                        style={{
                            display: "flex",
                            background: "rgba(210, 215, 211, 0.4)",
                            padding: "12px",
                            borderRadius: "12px",
                        }}
                    >
                        <div>
                            <input type="file" id="file" name="file" />
                        </div>
                        {/* src={mediaBlobUrl} */}
                        <button
                            type="submit"
                            style={{
                                border: "solid black 1px",
                                borderRadius: "4px",
                                padding: "4px",
                            }}
                        >
                            Upload Audio
                        </button>
                    </form>
                    <div>
                        <button
                            onClick={fetchAllAudio}
                            style={{
                                background: "rgba(210, 215, 211, 0.4)",
                                borderRadius: "4px",
                                padding: "4px",
                                margin: "4px",
                            }}
                        >
                            Display Audio Files
                        </button>
                        {audioArray.map((file) => {
                            return <div>{file.filename}</div>;
                        })}
                    </div>
                    <div>
                        <label htmlFor="Audio Name">Audio Name</label>
                        <input
                            type="text"
                            value={audioName}
                            onChange={(e) => setAudioName(e.target.value)}
                            style={{
                                color: "black",
                                borderRadius: "4px",
                                margin: "4px",
                            }}
                        />
                        <button
                            onClick={fetchAudio}
                            style={{
                                color: "black",
                                borderRadius: "4px",
                                margin: "4px",
                                background: "white",
                            }}
                        >
                            Fetch File
                        </button>
                        {audioLoaded && (
                            <audio src={audioFile} controls loop></audio>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PlaybackAudio;
